import { api } from '@marketplace-web/core-api/core-api-client-util'

import { DeleteItemReservationResp } from '../types/item-action-buttons'

export const markAsUnreserved = (item_id: number) =>
  api.delete<DeleteItemReservationResp>(`/items/${item_id}/reservation`)
